import { StreamRecording } from 'api/aiClips/types';

/** One playable source video on a review page. */
export interface SourceEntry {
  streamRecordId: number | null;
  /**
   * 1-based position among all of the stream's recordings, including ones without a video.
   * Null when the stream has one recording, and for the clip-record fallback.
   */
  partNumber: number | null;
  videoUrl: string;
  thumbnailUrl?: string | null;
  duration?: number | null;
}

/**
 * The stream's recordings as a playlist, in the order the API returns them (air time). Parts are
 * numbered over all recordings, then filtered, so a recording without a video cannot relabel
 * the ones after it.
 */
export function recordingsToSources(
  recordings: StreamRecording[]
): SourceEntry[] {
  return recordings
    .map((recording, idx) => ({
      streamRecordId: recording.id,
      partNumber: recordings.length > 1 ? idx + 1 : null,
      videoUrl: recording.videoURL ?? '',
      thumbnailUrl: recording.videoThumbnailURL,
      duration: recording.duration,
    }))
    .filter((source) => source.videoUrl);
}

/** The recordings, or the clip record's own video when none can be shown. */
export function buildSources(
  recordings: StreamRecording[],
  fallbackVideoUrl?: string | null
): SourceEntry[] {
  const playlist = recordingsToSources(recordings);
  if (playlist.length || !fallbackVideoUrl) return playlist;

  return [
    { streamRecordId: null, partNumber: null, videoUrl: fallbackVideoUrl },
  ];
}
